var styles = {"article":"StickyHeaderContentArea-module_article__dgjhh","inner":"StickyHeaderContentArea-module_inner__T1ltN","fixed-content-area":"StickyHeaderContentArea-module_fixed-content-area__X4Mbk"};

export { styles as default };
